import React, { useEffect } from "react";

export default function ImagePopup(props) {
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        props.onClose()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  return (
    <div className="popup-image" id="popup-image">
      <div className="background" onClick={props.onClose}></div>
      <div className="content">
        <div className="images-view">
          <img src={props.src} alt="" />
        </div>
      </div>
    </div>
  )
}